import React from 'react';

/** Page shell — matches /sales/orders spacing */
export function ListPageShell({ children }) {
  return <div className="space-y-4">{children}</div>;
}

/** Title row with optional right-side action */
export function ListPageHeader({ title, subtitle, action }) {
  return (
    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
      <div>
        <h1 className="page-title">{title}</h1>
        {subtitle && <p className="text-sm text-sap-textLight mt-0.5">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}

const SearchIcon = () => (
  <svg className="absolute left-3 top-1/2 -translate-y-1/2 text-sap-textMuted" width="16" height="16"
    viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" />
  </svg>
);

/** Search input with magnifier — matches Sales Orders */
export function ListSearchBar({ value, onChange, onChangeExtra, placeholder, className = '' }) {
  return (
    <div className={`relative flex-1 min-w-0 basis-full sm:basis-auto ${className}`}>
      <SearchIcon />
      <input
        value={value}
        onChange={(e) => {
          onChange(e.target.value);
          onChangeExtra?.();
        }}
        placeholder={placeholder}
        className="search-input pl-10"
      />
    </div>
  );
}

/** Filter select — matches Sales Orders */
export function ListFilterSelect({ value, onChange, onChangeExtra, children, className = '' }) {
  return (
    <select
      value={value}
      onChange={(e) => {
        onChange(e.target.value);
        onChangeExtra?.();
      }}
      className={`border border-sap-border rounded-xl px-3 sm:px-4 py-2.5 text-sm focus:outline-none focus:ring-2 focus:ring-sap-blue/20 focus:border-sap-blue bg-white shrink-0 ${className}`}
    >
      {children}
    </select>
  );
}

/** Standard pagination footer */
export function ListPagination({ page, totalPages, total, onPageChange }) {
  if (totalPages <= 1) return null;
  return (
    <div className="flex items-center justify-between text-xs text-sap-textLight">
      <span>{total} record{total !== 1 ? 's' : ''}</span>
      <div className="flex gap-1">
        <button
          type="button"
          disabled={page === 1}
          onClick={() => onPageChange(page - 1)}
          className="px-2.5 py-1 rounded-lg border border-sap-border disabled:opacity-40 hover:bg-sap-blue/5 transition-colors"
        >
          ‹
        </button>
        <span className="px-2.5 py-1">{page} / {totalPages}</span>
        <button
          type="button"
          disabled={page === totalPages}
          onClick={() => onPageChange(page + 1)}
          className="px-2.5 py-1 rounded-lg border border-sap-border disabled:opacity-40 hover:bg-sap-blue/5 transition-colors"
        >
          ›
        </button>
      </div>
    </div>
  );
}
